import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sharedInformation",
  "use": "icon-sharedInformation-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-sharedInformation\">\n<path class=\"st0\" d=\"M161.2,17.7H40.9c-14.7,0-26.7,12-26.7,26.7v77.8c0,14.7,12,26.7,26.7,26.7h15.4l11.4,29.4c1.3,2.7,3.4,4,6,4\n\tc2.7,0,5.3-1.3,6-4L91,148.9h68.8c14.7,0,26.8-12,26.8-26.7V44.4C187.9,29.7,175.9,17.7,161.2,17.7z M174.5,122.2\n\tc0,7.4-6,13.3-13.3,13.4H87.6c-2.7,0-5.3,1.4-6,4l-7.4,18.1l-7.3-18.1c-1.3-2.6-3.3-4-6-4H40.9c-7.4,0-13.3-6-13.4-13.4V44.4\n\tc0-7.3,6-13.4,13.4-13.4h120.3c7.3,0,13.3,6,13.3,13.4V122.2z M51,84.4c0,5.2,4.2,9.4,9.4,9.4s9.4-4.2,9.4-9.4S65.6,75,60.4,75\n\tS51,79.2,51,84.4z M90.4,84.4c0,5.2,4.2,9.4,9.4,9.4c5.2,0,9.4-4.2,9.4-9.4s-4.2-9.4-9.4-9.4C94.6,75,90.4,79.2,90.4,84.4z\n\t M129.9,84.4c0,5.2,4.2,9.4,9.4,9.4c5.2,0,9.4-4.2,9.4-9.4s-4.2-9.4-9.4-9.4C134.1,75,129.9,79.2,129.9,84.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sharedInformation.svg
// module id = uHbv
// module chunks = 183